import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { StaffBasicInfo } from '../../Models/GlobalEntities';
import { StaffDevice } from '../../Models/RequestModels';
import { UserService } from '../../Services/UserService';
import { DeviceAllocationTypes, EntityCodes } from '../../Models/EnumModels';
import { UploadImage } from '../UploadImage/UploadImage';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
    selector: 'UserProfile',
    templateUrl: './UserProfile.html',
})

export class UserProfile extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('content') content;
    @ViewChild('uploadImage') uploadImage: UploadImage;
    ModalRef: NgbModalRef;
    Model: StaffBasicInfo;
    DeviceList: Array<StaffDevice>;
    DisableModalOpenEvent: boolean = false;
    guid: any;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public userService: UserService) {
        super(translate, toastr, route, router, masterService);        
    }

    ngOnInit(): void {
        this.userService.StaffImageUpdated.pipe(untilDestroyed(this)).subscribe(value => {
            this.guid = this.generateGuid();
        })
    }

    ngOnDestroy(): void {
    }

    Open(): void {
        if (this.DisableModalOpenEvent) return;
        this.Model = new StaffBasicInfo();
        this.Model = this.masterService.LoggedInUserData;
        this.guid = this.generateGuid();
        this.userService.GetUserDeviceList(this.Model.StaffId).then(data => {
            if (data) {
                this.DeviceList = data.filter(obj => obj.DeviceAllocationType == DeviceAllocationTypes.Primary);                
            }           
        })
        this.ModalRef = this.modalService.open(this.content, { centered: true, backdrop:'static' });
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    onUploadImage() {
        this.uploadImage.Open(null, EntityCodes.Staff)
    }

    generateGuid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    onNotificationSound(event: any) {
        this.userService.AlertSound(this.Model.IsAlertPopupAudioEnabled).then(data => {
            if (data.HasError) {
                this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
                this.Model.IsAlertPopupAudioEnabled = !this.Model.IsAlertPopupAudioEnabled;
                return;
            }
            this.GetMultilingualToast('Alert setting changed successfully','success');
        })
    }
}
